import { ContinueButtonTypes } from '@core/blocks/edu-flow/components/Page/types';

import continueButtonsTypeDictionary, {
  type ContinueButton as ContinueButtonType,
} from './continueButtonsTypeDictionary';

export type Props = {
  type?: ContinueButtonTypes;
};

export type ContinueButtonComponentProps = ContinueButtonType<Props>;

const ContinueButton: ContinueButtonComponentProps = ({ type = ContinueButtonTypes.DEFAULT_BUTTON, ...otherProps }) => {
  const CButton = continueButtonsTypeDictionary[type];

  return <CButton {...otherProps} />;
};

export default ContinueButton;
